/** Map Supabase / auth failures to clear login-page messages */
export function getLoginErrorMessage(err: unknown): string {
  if (!err) return 'Something went wrong. Please try again.';

  const anyErr = err as {
    message?: string;
    code?: string;
    status?: number;
    name?: string;
  };

  const code = (anyErr.code || '').toLowerCase();
  const message = (anyErr.message || '').toLowerCase();
  const status = anyErr.status;

  if (
    code === 'invalid_credentials' ||
    message.includes('invalid login credentials') ||
    message.includes('invalid email or password')
  ) {
    return 'Invalid email or password. Please check your credentials and try again.';
  }

  if (code === 'email_not_confirmed' || message.includes('email not confirmed')) {
    return 'Your email address has not been confirmed yet. Please check your inbox.';
  }

  if (
    code === 'user_banned' ||
    message.includes('user is banned') ||
    message.includes('banned')
  ) {
    return 'This account has been suspended. Contact support for help.';
  }

  if (
    code === 'too_many_requests' ||
    status === 429 ||
    message.includes('rate limit') ||
    message.includes('too many requests')
  ) {
    return 'Too many sign-in attempts. Please wait a moment and try again.';
  }

  if (
    message.includes('network') ||
    message.includes('failed to fetch') ||
    message.includes('fetch failed')
  ) {
    return 'Unable to reach the authentication server. Check your connection and try again.';
  }

  if (message.includes('session was returned') || message.includes('session was established') || message.includes('no session')) {
    return 'Sign-in succeeded but your session could not be saved. Please try again.';
  }

  if (anyErr.message && anyErr.message.trim().length > 0) {
    // Prefer the upstream message when it is already readable
    return anyErr.message;
  }

  return 'Invalid email or password. Please try again.';
}

export function getLoginQueryErrorMessage(errorParam: string | null): string | null {
  if (!errorParam) return null;
  switch (errorParam) {
    case 'session':
      return 'Your session could not be established. Please sign in again.';
    case 'auth':
      return 'Authentication failed. Please try again.';
    case 'access':
      return 'You do not have access to that page with your current role.';
    default:
      return 'Something went wrong during sign-in. Please try again.';
  }
}
